import { useMemo } from "react";
import { usePublishedJobs } from "@/hooks/useJobPosts";
import { useMyApplications } from "@/hooks/useJobApplications";

const STORAGE_KEY = "vagas_last_visit";

function getLastVisit(): Date {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) return new Date(stored);
  // Default to 7 days ago on first use
  const d = new Date();
  d.setDate(d.getDate() - 7);
  return d;
}

export function markVagasVisited() {
  localStorage.setItem(STORAGE_KEY, new Date().toISOString());
}

export function useVagasNotifications() {
  const { data: jobs } = usePublishedJobs();
  const { applications } = useMyApplications();

  const count = useMemo(() => {
    const lastVisit = getLastVisit();

    // Count new jobs published since last visit
    const newJobs = (jobs ?? []).filter(
      (j) => j.published_at && new Date(j.published_at) > lastVisit
    ).length;

    // Count applications with status changes since last visit
    const updatedApps = applications.filter(
      (a) => new Date(a.updated_at) > lastVisit && a.status !== "aplicada"
    ).length;

    return newJobs + updatedApps;
  }, [jobs, applications]);

  return count;
}
